import usei18n from "@app-i18n/index";
import { useRule } from "@qamf/lighthouse";
import { email as emailRule, required as requiredRule } from "@vee-validate/rules";

const { translateKey } = usei18n();
export const { defineRule } = useRule();

export function useRuleMinLength(name: string) {
	defineRule(name, (value, [limit]) => {
		if (!value || !value.length)
			return true;

		if (value.length < limit)
			return false;

		return true;
	});
}

export function useRuleMaxLength(name: string) {
	defineRule(name, (value, [limit]) => {
		if (!value || !value.length)
			return true;

		if (value.length > limit)
			return false;

		return true;
	});
}

export function useRuleTextMaxLength(name: string, len: number) {
	if (len <= 0) return;
	defineRule(name, (value?: string) => {
		if ((value?.length ?? 0) <= len) return true;
		return translateKey("form_text_to_long");
	});
}
export function useRuleTextMaxLengthSize(name: string, size: "xs" | "sm" | "ms" | "md" | "lg" | "xl" = "sm") {
	const sizesMap = {
		xs: 20,
		sm: 50,
		ms: 100,
		md: 500,
		lg: 2000,
		xl: 20000
	};
	const len = size in sizesMap ? sizesMap[size] : 0;
	useRuleTextMaxLength(name, len);
}
export function useRulePhoneNumber(name: string) {
	defineRule(name, (value: string) => {
		const phone = /^[+-]?[^\D\r\t\n)][\d()\- ]{1,18}$/;
		const duplicates = /(([()\- )])\2+)/;
		return phone.test(value) && !duplicates.test(value) ? true : translateKey("form_invalid_phone_number");
	});
}
export function useRuleDateRequired(name: string) {
	defineRule(name, (value: Date) => {
		return value instanceof Date && !isNaN(+value) ? true : translateKey("form_invalid_field");
	});
}
export function useRuleBowlersRequired(name: string) {
	defineRule(name, (value: any[]) => {
		if (!value || !value.length) return false;
		return (value.reduce((accumulator, type) => accumulator + type.Quantity, 0) > 0);
	});
}
export function useCustomRequiredRule(ruleName: string, message: string) {
	defineRule(ruleName, (value) => {
	  const isValid = requiredRule(value);
	  return isValid === true ? true : message;
	});
}
export function useCustomEmailRule(ruleName: string, message: string) {
	defineRule(ruleName, (value) => {
	  const isValid = emailRule(value);
	  return isValid === true ? true : message;
	});
}
